import React from 'react';
import { formatCurrency } from '../../../../data/shared/money';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import i18n from '../../../../i18n'
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";

const Root = ({ isActive, onClick = null, children }) =>
    <div className={cx("wb-line flex-col rounded my-5", {'item-active': isActive})} onClick={onClick}>
        {children}
    </div>
;

const Date = ({ date, className }) =>
    <div className={cx("wb-cell justify-center", className)}>
        <div className="day">{date.format('DD')}</div>
        <div className="month px-1">{date.format('MMMM')}</div>
        <div className="year">{date.format('YYYY')}</div>
    </div>
;

const Quantity = ({ quantity, icon }) =>
    <div className="wb-cell quantity border-l-2">
        {quantity}
        <i className={cx('fa', 'fa-' + icon)} aria-hidden="true" />
    </div>
;

const Departure = ({ departure }) =>
    <div className={cx("flex justify-center text-sm")}>
        {departure}
    </div>
;

const SubContractor = () =>
    <div className="wb-cell subContractor" dangerouslySetInnerHTML={{__html: i18n.t('booking.partner_provided')}} />
;

const FromTo = ({ from, to, departure = null }) =>
    <div className="wb-cell main-cell transport-step">
        {departure && <div className="flex text-sm">Départ :<strong className='ml-1'>{departure}</strong></div>}
        <div className="start-stop">
            {from.stop && from.stop.title && <span className="lodging">{from.stop.title}</span>}
            {!isEmpty(from.locality) &&
                <span className="location">
                    {from.step.title} - {from.locality.title}
                </span>
            }
            {isEmpty(from.locality) && from.step && <span className="location">
                    {from.step.title}
                </span>}
            {(!from.stop || !from.stop.title) &&
                <span className="lodging flex font-medium text-orange-500">

                <ExclamationTriangleIcon
                    className={`mr-1 h-5 w-5`}/> En attente d'informations</span>
            }
        </div>
        <div className="end-stop mt-2">
            {to.stop && to.stop.title ? <span className="lodging">
                <i className="fa fa-long-arrow-right mr-1" aria-hidden="true"/>
                {to.stop.title}
            </span> : <i className="fa fa-long-arrow-right" aria-hidden="true"/>}
            {!isEmpty(to.locality) &&
                <span className="location">
                    {to.step.title} - {to.locality.title}
                </span>
            }
            {isEmpty(to.locality) && to.step &&
                <span className="location">
                    {to.step.title}
                </span>}
            {(!to.stop || !to.stop.title) &&
                <span className="lodging flex font-medium text-orange-500">

                <ExclamationTriangleIcon
                    className={`mr-1 h-5 w-5`}/> En attente d'informations</span>
            }
        </div>
    </div>
;

const Place = ({ place }) =>
    <div className="wb-cell main-cell transport-step">
        <div className="start-stop">
            {place.stop && <span className="lodging">{place.stop.title}</span>}
            {!isEmpty(place.locality) &&
                <span className="location">
                    {place.step.title} - {place.locality.title}
                </span>
            }
            {isEmpty(place.locality) && place.step && <span className="location">
                    {place.step.title}
                </span>}
        </div>

    </div>
;

const Places = ({ place}) =>
    <div className="wb-cell fromto">
        <div className="lodging wb-cell">

            <i className="fa fa-flag" aria-hidden="true"/>
            &nbsp;{place.title}
        </div>

    </div>
;

const Price = ({ price }) =>
    <div className="wb-cell justify-center bg-gray-200 shadow-inner">
        <div className="inner-cell">
            {formatCurrency(price)}
        </div>
    </div>
;

const RightAction = ({ children, onClick = () => {} }) =>
    <div className="wb-cell action-cell" onClick={onClick}>
        {children}
    </div>
;

const Designation = ({ designation }) =>
    <div className="wb-cell designation">
        <div className="inner-cell">
            {designation}
        </div>
    </div>
;

const Comment = ({ comment }) =>
    <div className="wb-cell designation">
        <div className="inner-cell">
            {comment}
        </div>
    </div>
;

export {
    Root,
    Date,
    Quantity,
    Departure,
    SubContractor,
    FromTo,
    Price,
    Designation,
    Comment,
    RightAction,
    Place
};
